import { useState, useEffect } from 'react';
import HubSpotIcon from '../../../../images/hubspot.png'
import IntercomIcon from '../../../../images/intercom.png'
import DropdownClassic from "../../../../components/DropdownClassic";

function MarketingCampaignsCard({data, integrationName, viewDetail, updateSelectedItems}) {

  const handleIcon = (id) => {
    switch (id) {
      case 'HubSpot':
        return (
          <img className="rounded-full bg-white mr-2" src={HubSpotIcon} width="36" height="36" />
        );
      case 'Intercom':
        return (
          <img className="rounded-full bg-white mr-2" src={IntercomIcon} width="36" height="36" />
        );
      default:
        return (
          <svg className="flex-shrink-0 mr-2 sm:mr-3" width="36" height="36" viewBox="0 0 36 36">
            <circle fill="#24292E" cx="18" cy="18" r="18" />
            <path d="M18 10.2c-4.4 0-8 3.6-8 8 0 3.5 2.3 6.5 5.5 7.6.4.1.5-.2.5-.4V24c-2.2.5-2.7-1-2.7-1-.4-.9-.9-1.2-.9-1.2-.7-.5.1-.5.1-.5.8.1 1.2.8 1.2.8.7 1.3 1.9.9 2.3.7.1-.5.3-.9.5-1.1-1.8-.2-3.6-.9-3.6-4 0-.9.3-1.6.8-2.1-.1-.2-.4-1 .1-2.1 0 0 .7-.2 2.2.8.6-.2 1.3-.3 2-.3s1.4.1 2 .3c1.5-1 2.2-.8 2.2-.8.4 1.1.2 1.9.1 2.1.5.6.8 1.3.8 2.1 0 3.1-1.9 3.7-3.7 3.9.3.4.6.9.6 1.6v2.2c0 .2.1.5.6.4 3.2-1.1 5.5-4.1 5.5-7.6-.1-4.4-3.7-8-8.1-8z" fill="#FFF" />
          </svg>
        );
    }
  };

  const defaultRow = <tr key="1" role="row">
    <td className="p-2">
    </td>
    <td className="p-2">
      <div className="text-center"></div>
    </td>
    <td className="p-2">
      <div className="text-center text-green-500"></div>
    </td>
    <td className="p-2">
      <div className="text-center"></div>
    </td>
    <td className="p-2">
      <div className="text-center text-light-blue-500">
          No campaign data found</div>
    </td>
  </tr>
  const [isCheck, setIsCheck] = useState([]);
  const [rows, setRows] = useState(null);
  const [topicList, setTopicList] = useState([]);
  const [toneList, setToneList] = useState([]);
  const [ctaList, setCTAList] = useState([]);
  const [urgencyList, setUrgencyList] = useState([]);

  const [selectedTopic, setSelectedTopic] = useState('all');
  const [selectedTone, setSelectedTone] = useState('all');
  const [selectedCTA, setSelectedCTA] = useState('all');
  const [selectedUrgency, setSelectedUrgency] = useState('all');
  const [emails, setEmails] = useState([]);

  useEffect(() => {
      if(data!=null)
          data = data.map(item => { return {...item, checked: false}})
      setEmails(data)
  }, [data, integrationName]);

  useEffect(() => {
        if(emails!=null && emails.length>0) {
            populateTopicFilter(emails)
            populateToneFilter(emails)
            populateCTAFilter(emails)
            populateUrgencyFilter(emails)

            setRows(emails.map( (item) =>
                createRow(item)
            ));
            updateSelectedItems(emails.filter(item => item.checked))
        }

    }, [emails]);

  function populateTopicFilter(data){
    var topicN = 1
    var topics = [{id: 0, period: 'all'}]
    var keys = Object.keys(data[0])
    for(var i in keys){
      if(keys[i].includes('topic_')) {
        topics.push({id: topicN, period: keys[i].replace('topic_', '')})
        topicN = topicN+1
      }
    }
    setTopicList(topics)
  }

  function populateToneFilter(data){
    var toneN = 1
    var tones = [{id: 0, period: 'all'}]
    var keys = Object.keys(data[0])
    for(var i in keys){
      if(keys[i].includes('tone_')) {
        tones.push({id: toneN, period: keys[i].replace('tone_', '')})
        toneN = toneN+1
      }
    }
    setToneList(tones)
  }

  function populateCTAFilter(data){
    var ctaN = 1
    var ctas = [{id: 0, period: 'all'}]
    var keys = Object.keys(data[0])
    for(var i in keys){
      if(keys[i].includes('cta_')) {
        ctas.push({id: ctaN, period: keys[i].replace('cta_', '')})
        ctaN = ctaN+1
      }
    }
    setCTAList(ctas)
  }

  function populateUrgencyFilter(data){
    var urgencyN = 1
    var urgency = [{id: 0, period: 'all'}]
    var keys = Object.keys(data[0])
    for(var i in keys){
      if(keys[i].includes('urgency_')) {
        urgency.push({id: urgencyN, period: keys[i].replace('urgency_', '')})
        urgencyN = urgencyN+1
      }
    }
    setUrgencyList(urgency)
  }

  function createRow(item){
      return <tr key={item.id} role="row" className="hover:bg-yellow-50">
          <td className="p-2">
              <div className="flex items-center">
                  <input id={item.id} className="form-checkbox cursor-pointer text-yellow-500" type="checkbox" onChange={()=>handleClick(item.id, item.checked)} checked={item.checked} />
              </div>
          </td>
          <td className="p-2">
              <div className="flex items-center">
                  {handleIcon(integrationName)}
              </div>
          </td>
          <td className="p-2">
              <div className="flex text-left line-clamp-1">{item.date.split(' ')[0]}</div>
          </td>
          <td className="p-2">
              <div className="flex text-left line-clamp-1">{item.author}</div>
          </td>
          <td className="p-2">
              <div className="flex items-center">
                  <div className="text-gray-800 line-clamp-1">{item.fulltext}</div>
              </div>
          </td>
          <td className="p-2">
              <div className="flex items-center">
                  <div className="hover:text-yellow-600 text-gray-500 line-clamp-1 cursor-pointer" onClick={(e)=> {
                      e.stopPropagation()
                      viewDetail(item)
                  }}>
                      <svg  className="flex-shrink-0 h-6 w-6 mr-3" viewBox="0 0 24 24">
                          <path className="fill-current " d="M3.936,7.979c-1.116,0-2.021,0.905-2.021,2.021s0.905,2.021,2.021,2.021S5.957,11.116,5.957,10
								S5.052,7.979,3.936,7.979z M3.936,11.011c-0.558,0-1.011-0.452-1.011-1.011s0.453-1.011,1.011-1.011S4.946,9.441,4.946,10
								S4.494,11.011,3.936,11.011z M16.064,7.979c-1.116,0-2.021,0.905-2.021,2.021s0.905,2.021,2.021,2.021s2.021-0.905,2.021-2.021
								S17.181,7.979,16.064,7.979z M16.064,11.011c-0.559,0-1.011-0.452-1.011-1.011s0.452-1.011,1.011-1.011S17.075,9.441,17.075,10
								S16.623,11.011,16.064,11.011z M10,7.979c-1.116,0-2.021,0.905-2.021,2.021S8.884,12.021,10,12.021s2.021-0.905,2.021-2.021
								S11.116,7.979,10,7.979z M10,11.011c-0.558,0-1.011-0.452-1.011-1.011S9.442,8.989,10,8.989S11.011,9.441,11.011,10
								S10.558,11.011,10,11.011z"></path>
                      </svg>
                  </div>
              </div>
          </td>
      </tr>
  }

  function filterTopics(topic){
    setSelectedTone('all')
    setSelectedCTA('all')
    setSelectedUrgency('all')
    if(topic==='all')
      var tmp = emails
    else
      var tmp = emails.filter(function(item)
    {
      return item['topic_'+topic]>0.2
    });
    setRows(tmp.map( (item) =>
        createRow(item)
    ));
  }

  function filterTones(tone){
    setSelectedTopic('all')
    setSelectedCTA('all')
    setSelectedUrgency('all')
    if(tone==='all')
      var tmp = emails
    else
      var tmp = emails.filter(function(item)
    {
      return item['tone_'+tone]>0.2
    });
    setRows(tmp.map( (item) =>
        createRow(item)
    ));
  }

  function filterCTA(cta){

    setSelectedTopic('all')
    setSelectedTone('all')
    setSelectedUrgency('all')
    if(cta==='all')
      var tmp = emails
    else
      var tmp = emails.filter(function(item)
    {
      return item['cta_'+cta]>0.2
    });
    setRows(tmp.map( (item) =>
        createRow(item)
    ));
  }

  function filterUrgency(urgency){

    setSelectedTopic('all')
    setSelectedCTA('all')
    setSelectedTone('all')
    if(urgency==='all')
      var tmp = emails
    else
      var tmp = emails.filter(function(item)
    {
      return item['urgency_'+urgency]>0.2
    });
    setRows(tmp.map( (item) =>
        createRow(item)
    ));
  }

  function handleClick(id, checked){
      setEmails(emails.map(item =>  item.id===id? {...item, checked: !checked}:item))
  }

  return (
      <div>
        {topicList.length>0 && toneList.length>0 && ctaList.length>0 && urgencyList.length>0?
            <div className="flex mb-2 justify-between">
              <div className="flex">
                <p className="mr-2 my-auto">Topic:</p>
                <DropdownClassic options={topicList} selectedFilter={selectedTopic} updateFunc={filterTopics}/>
              </div>
              <div className="flex">
                <p className="mr-2 my-auto">Tone:</p>
                <DropdownClassic options={toneList} selectedFilter={selectedTone} updateFunc={filterTones}/>
              </div>
              <div className="flex">
                <p className="mr-2 my-auto">CTA:</p>
                <DropdownClassic options={ctaList} selectedFilter={selectedCTA} updateFunc={filterCTA}/>
              </div>
              <div className="flex">
                <p className="mr-2 my-auto">Urgency:</p>
                <DropdownClassic options={urgencyList} selectedFilter={selectedUrgency} updateFunc={filterUrgency}/>
              </div>
            </div>:''}
        <div className="col-span-full bg-white shadow-1 rounded-sm border
                        border-gray-200 flex flex-col max-h-72 min-h-72 overflow-y-scroll">
          {/*<header className="px-5 py-4 border-b border-gray-100">
            <h2 className="font-semibold text-gray-800">Marketing Campaigns 🚀</h2>
          </header>*/}
          <div className="p-3 flex-initial">
            {/* Table */}
            <div className="overflow-x-auto">
              <table className="table-auto w-full">
                {/* Table header */}
                <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                  <tr>
                  <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap w-px">
                      <div className="flex items-center"></div>
                  </th>
                    <th className="p-2">
                      <div className="font-semibold text-left"></div>
                    </th>
                    <th className="p-2 w-1/12">
                      <div className="font-semibold text-left">Date</div>
                    </th>
                    <th className="p-2 w-1/6">
                      <div className="font-semibold text-left">Author</div>
                    </th>
                    <th className="p-2">
                      <div className="font-semibold text-left">Content</div>
                    </th>
                      <th className="p-2">
                          <div className="font-semibold text-left"></div>
                      </th>
                  </tr>
                </thead>
                {/* Table body */}
                <tbody className="text-sm font-medium divide-y divide-gray-100">
                  {
                    rows==null?defaultRow:rows
                  }
                </tbody>
              </table>

            </div>
          </div>
        </div>
      </div>
  );
}

export default MarketingCampaignsCard;
